import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Select } from "@libs/rubick";
import { FILTER_VALUES } from "@/constants/filters";
import { SHARED_TIME_RANGE_OPTIONS } from "@/constants/timeRange";
import useUtilizationDeepDiveStore from "@/context/utilization/useUtilizationDeepDiveStore";
import { shortApiKey } from "./utils";
function UtilizationFilters({ filterableApiKeysCount, includesHistoricalApiKeys, selectableApiKeys }) {
    const { filters, setSelectedApiKey, setSelectedPeriod } = useUtilizationDeepDiveStore();
    return /*#__PURE__*/ _jsx(Card, {
        variant: "bordered",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "grid grid-cols-1 gap-5 lg:grid-cols-2",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-xs font-semibold uppercase tracking-wider text-gray-500",
                            children: "Period"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-2 inline-flex rounded-lg bg-gray-100 p-1",
                            children: SHARED_TIME_RANGE_OPTIONS.map((option)=>{
                                const isActive = option.value === filters.selectedPeriod;
                                return /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>setSelectedPeriod(option.value),
                                    className: `rounded-md px-3 py-1.5 text-sm transition ${isActive ? "bg-navy-70 text-white font-medium" : "text-gray-600 hover:bg-gray-200"}`,
                                    children: option.label
                                }, option.value);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            htmlFor: "utilization-deep-dive-api-key",
                            className: "text-xs font-semibold uppercase tracking-wider text-gray-500",
                            children: "API Key"
                        }),
                        /*#__PURE__*/ _jsxs(Select, {
                            id: "utilization-deep-dive-api-key",
                            value: filters.selectedApiKey,
                            onChange: (event)=>setSelectedApiKey(event.target.value),
                            className: "mt-2",
                            children: [
                                /*#__PURE__*/ _jsx("option", {
                                    value: FILTER_VALUES.ALL,
                                    children: "All API Keys"
                                }),
                                selectableApiKeys.map((apiKey)=>/*#__PURE__*/ _jsxs("option", {
                                        value: apiKey.id,
                                        children: [
                                            apiKey.name || shortApiKey(apiKey.id),
                                            " (",
                                            shortApiKey(apiKey.id),
                                            ")",
                                            apiKey.status === "Active" ? "" : ` (${apiKey.status})`
                                        ]
                                    }, apiKey.id))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mt-1 text-xs text-gray-500",
                            children: [
                                filterableApiKeysCount,
                                " ",
                                includesHistoricalApiKeys ? "historical" : "active",
                                " key",
                                filterableApiKeysCount === 1 ? "" : "s",
                                " available",
                                filterableApiKeysCount > 20 ? " (showing first 20)" : ""
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
export { UtilizationFilters };
